import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Header {
    constructor(){
        this.header = {
            el: document.querySelector('header'),
            content: document.querySelectorAll('header nav'),
        };

        this.menu = {
            logo: document.querySelector('header .logo-resolve'),
        }

        this.footer = document.querySelector('footer');

        this.company = document.getElementById('company');
    }

    init(){
        // this.clip();
        if(Sniff.features.mobile){
            
            // this.set();
            // this.animation();
        }
    }

    clip = () => {
        window.addEventListener('scroll', () => {
            if(window.pageYOffset >= 50){
                this.menu.logo.classList.add('clip');
            } else {
                this.menu.logo.classList.remove('clip');
            }
        });
    }

    set = () => {
        // Set using GSAP
    }

    animation = () => {
        // Animate using GSAP
    }
}
